import { gql, useLazyQuery, useSubscription } from '@apollo/client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'src/common/constants';
import { ErrorMessage } from 'src/enum/messsage-enum';
import { getLogMaintenance, getMstUser } from 'src/graphql/queries';
import { insertedLogMaintenance } from 'src/graphql/subscriptions';
import Maintenance from '../maintenance';

const ListSample = () => {
  const [muMail, setMuMail] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const { user, signOut } = useAuthenticator((context) => [context.user]);

  const [searchMstUser, { data: mstUserData, loading: isMstUserLoading, error: mstUserError }] = useLazyQuery(
    gql(getMstUser),
    {
      fetchPolicy: 'network-only',
      onError: (error) => {
        // Timeoutの場合はaurora側の起動時間Issueととらえ、リトライする
        if (error?.message === ErrorMessage.GRAPH_QL_TIME_OUT) {
          searchMstUser({ variables: { input: muMail ? { mu_mail: muMail } : undefined } });
        } else {
          window.alert('Searching mst_user error');
        }
      },
    }
  );

  // リアルタイムのlog_maintenance監視処理
  // 新しくページをロードするUserに対する処理
  const [searchLogMaintenance, { data: logMData, error: logMError }] = useLazyQuery(gql(getLogMaintenance), {
    nextFetchPolicy: 'network-only',
    onError: (error) => {
      // Timeoutの場合はaurora側の起動時間Issueととらえ、リトライする
      if (error?.message === ErrorMessage.GRAPH_QL_TIME_OUT) {
        searchLogMaintenance();
      } else {
        window.alert('Searching log_maintenance error');
      }
    },
  });

  // 操作中のUserに対する処理
  const { data: subInsLogData, error: subInsLogError } = useSubscription(gql(insertedLogMaintenance));
  // const { data: subDelLogData, error: subDelLogError } = useSubscription(gql(deletedLogMaintenance));

  useEffect(() => {
    searchLogMaintenance();
    searchMstUser({ variables: { input: muMail ? { mu_mail: muMail } : undefined } });
  }, []);

  // GraphQL Clientでエラーが発生した場合の処理
  if (mstUserError && mstUserError.message !== ErrorMessage.GRAPH_QL_TIME_OUT)
    <div>{`Error! ${mstUserError.message}`}</div>;
  if (logMError) <div>{`Error! ${logMError.message}`}</div>;
  if (subInsLogError) <div>{`Error! ${subInsLogError.message}`}</div>;
  // if (subDelLogError) <div>{`Error! ${subDelLogError.message}`}</div>;

  // OnClick Search
  const handleSearch = () => {
    Auth.currentAuthenticatedUser().catch(() => {
      signOut();
      navigate(LOGIN_PATH, { replace: true, state: { from: location } });
    });

    searchMstUser({ variables: { input: muMail ? { mu_mail: muMail } : undefined } });
  };

  const handleSignOut = () => {
    signOut();
    navigate(LOGIN_PATH, { replace: true });
  };

  if (logMData?.getLogMaintenance.length > 0 || subInsLogData) return <Maintenance />;

  return (
    <div className="flex justify-center">
      <div className="flex flex-col w-80">
        <div>Login User : {user?.username}</div>
        <div className="flex mt-4">
          <span className="flex-grow" />
          <button className="px-2" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>
        <div className="flex mt-4">
          <span className="flex-grow" />
          <button className="border border-black bg-gray-300 w-20">
            <Link to="/entry">新規作成</Link>
          </button>
        </div>
        <div className="mt-4">
          <div className="flex my-1">
            <label className="w-16">E-Mail</label>
            <input className="border border-black" onChange={(e) => setMuMail(e.target.value)} />
          </div>
        </div>
        <div className="flex mt-2">
          <span className="flex-grow" />
          <button className="border border-black bg-gray-300 w-20" onClick={handleSearch}>
            検索
          </button>
        </div>
        <div className="mt-4">
          <table>
            <thead>
              <tr>
                <th className="border border-black w-28">E-Mail</th>
                <th className="border border-black w-28">User ID</th>
                <th className="border border-black w-28">User Name</th>
                <th className="border border-black w-28">Office Code</th>
                <th className="border border-black w-28">Admin</th>
              </tr>
            </thead>
            <tbody>
              {isMstUserLoading ? (
                <tr>
                  <td colSpan={5} className="text-center animate-pulse">
                    Loading...
                  </td>
                </tr>
              ) : (
                mstUserData?.getMstUser?.map((el: any) => (
                  <tr key={el.mu_mail}>
                    <td className="border border-black text-blue-400 underline">
                      <Link to="/entry" state={{ muMail: el.mu_mail }}>
                        {el.mu_mail}
                      </Link>
                    </td>
                    <td className="border border-black">{el.mu_user_id}</td>
                    <td className="border border-black">{el.mu_user_nm}</td>
                    <td className="border border-black">{el.mu_office_cd}</td>
                    <td className="border border-black">
                      <input readOnly type="checkbox" checked={Boolean(el.mu_admin_kb)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListSample;
